import React, { useState } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { BaseFormFields, useBaseForm } from "./BaseFormFields";

export function QuestionForm({ onSubmit, initialData, readOnly, submitting, onTitleChange, allowedPriorities, ticketType, onTypeChange }) {
    const baseForm = useBaseForm("low");
    const [topic, setTopic] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({
            title: baseForm.title,
            description: baseForm.description,
            priority: baseForm.priority,
            dynamic_fields: {
                topic: topic,
            },
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            <BaseFormFields
                ticketType={ticketType}
                onTypeChange={onTypeChange}
                {...baseForm}
                onTitleChange={onTitleChange}
                    allowedPriorities={allowedPriorities}
                titlePlaceholder="Ex: Comment réinitialiser mon mot de passe VPN ?"
                descriptionPlaceholder="Détaillez votre question..."
            >
                <div className="form-group">
                    <Label className="form-label">Sujet / Thème</Label>
                    <Input
                        value={topic}
                        onChange={(e) => setTopic(e.target.value)}
                        placeholder="Ex: VPN, Messagerie, Impression..."
                        data-testid="topic"
                    />
                </div>
            </BaseFormFields>

            <div className="mt-6 flex justify-end">
                <Button type="submit" disabled={!baseForm.title || submitting} data-testid="submit-ticket">
                    {submitting ? "Création..." : "Soumettre le ticket"}
                </Button>
            </div>
        </form>
    );
}
